import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader, Header, Text, Button } from '@pet-notify/ui'

import { Status } from 'types/found-pet'
import ContactInformationPage from './ContactInformation'
import { useFoundPet, useUpdateStatus } from 'hooks/found-pets'

function ClaimPage() {
  const { token } = useParams()
  const foundPetQuery = useFoundPet(token)
  const updateStatusMutation = useUpdateStatus()
  const navigate = useNavigate()

  useEffect(() => {
    if (foundPetQuery.isError) {
      navigate('/found')
    }
  }, [foundPetQuery])

  if (foundPetQuery.isLoading || !foundPetQuery.data) {
    return <Loader />
  }

  const foundPet = foundPetQuery.data

  function handleGetContactInformation() {
    if (token) {
      updateStatusMutation.mutate({
        status: Status.GET_CONTACT_INFORMATION,
        token,
      })
    }
  }

  if (foundPet?.status === Status.PET_IS_SAFE) {
    return (
      <>
        <Header as='h1' size='xlarge' mb='4'>
          {foundPet?.pet.name} is marked as safe.
        </Header>

        <Button as='a' href='/'>
          Back to Pet Notify
        </Button>
      </>
    )
  }

  if (foundPet?.status === Status.GET_CONTACT_INFORMATION) {
    return <ContactInformationPage foundPet={foundPet} />
  }

  return (
    <>
      <Header as='h1' size='xlarge' mb='4'>
        {foundPet.pet.name} was lost but has been found!
      </Header>

      {updateStatusMutation.isLoading ? (
        <Loader />
      ) : (
        <Button mb='10' type='button' onClick={handleGetContactInformation}>
          Get contact information
        </Button>
      )}

      {foundPet.status === Status.EMERGENCY_CONTACTS_NOTIFIED && (
        <Text>
          If you don&apos;t respond within 15 minutes, we will notify your
          emergency contacts.
        </Text>
      )}
    </>
  )
}
export default ClaimPage
